import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ConnectorSettings from '../components/ConnectorSettings/ConnectorSettings';
import {
  listConnectors,
  deleteConnector,
  testConnector,
} from 'js/actions/connector-actions';
import { notify } from 'js/actions/alert-actions';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';
import { QueryBase } from 'js/store/reducers/queries';
import { useQuery } from 'js/hooks/useQuery';
import { SCHEMAS } from 'js/api/schemas';

function ConnectorSettingsContainer({
  listConnectors,
  deleteConnector,
  testConnector,
  notify,
  activeWorkspace,
  match,
}) {
  const workspaceId = activeWorkspace?.id;

  const refreshConnectorsQuery = useCallback(
    (queryId) => listConnectors(workspaceId, queryId),
    [workspaceId, listConnectors]
  );

  const {
    refresh: refreshConnectors,
    result: connectors,
    isLoading: connectorsIsLoading,
  } = useQuery({
    queryId: `${QueryBase.Connectors}-${workspaceId}`,
    query: refreshConnectorsQuery,
    schema: SCHEMAS.CONNECTOR_ARRAY,
  });

  useEffect(() => {
    refreshConnectors();
  }, [refreshConnectors]);

  const handleDeleteConnector = useCallback(
    async (connectorId) => {
      try {
        await deleteConnector(workspaceId, connectorId);
        notify({
          type: 'success',
          message: 'Connector deleted successfully',
        });
      } catch (error) {
        notify({
          type: 'danger',
          message: 'Failed to delete connector. Please try again.',
        });
        throw error;
      }
    },
    [workspaceId, deleteConnector, notify]
  );

  const handleTestConnector = useCallback(
    async (connectorId) => {
      try {
        const result = await testConnector(workspaceId, connectorId);
        notify({
          type: 'success',
          message: result.message || 'Connection test successful',
        });
      } catch (error) {
        notify({
          type: 'danger',
          message: 'Connection test failed. Please check your configuration.',
        });
        throw error;
      }
    },
    [workspaceId, testConnector, notify]
  );

  return (
    <ConnectorSettings
      workspace={activeWorkspace}
      connectors={connectors ?? []}
      isLoading={connectorsIsLoading}
      onDeleteConnector={handleDeleteConnector}
      onTestConnector={handleTestConnector}
      match={match}
    />
  );
}

const mapStateToProps = (state) => {
  const activeWorkspace = selectActiveWorkspace(state);

  return {
    activeWorkspace,
  };
};

const mapDispatchToProps = {
  listConnectors,
  deleteConnector,
  testConnector,
  notify,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConnectorSettingsContainer)
);
